<template>
  <v-card class="pa-6">
    <v-btn absolute top right @click="$emit('close')" text icon>
      <v-icon small> mdi-close </v-icon>
    </v-btn>

    <h3 class="my-4 text-center">{{ isEdit ? 'Editar vídeo' : 'Adicionar vídeo' }}</h3>

    <v-form ref="form">
      <v-text-field
        v-model="video.title"
        outlined
        :rules="[(v) => !!v || 'Título obrigatório']"
        dense
        placeholder="Adicione um título ao seu vídeo"
      ></v-text-field>

      <v-text-field
        v-model="video.link"
        outlined
        :rules="[(v) => !!v || 'Link obrigatório']"
        dense
        placeholder="Cole aqui o link do vídeo no vimeo"
      ></v-text-field>
    </v-form>

    <div class="d-flex">
      <v-spacer></v-spacer>
      <v-btn
        class="secondary-button mr-0"
        depressed
        @click="submit"
        :loading="loading"
      >
        Salvar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
export default {
  name: 'VideoManage',

  props: {
    engType: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      apiService: new ApiService(),
      video: this.item ? { ...this.item } : {},
      loading: false,
    }
  },

  computed: {
    isEdit() {
      return !!(this.item && this.item.id)
    },
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        const request = this.isEdit
          ? this.apiService.put(`video/${this.video.id}`, {
              ...this.video,
              engType: this.engType,
            })
          : this.apiService.post('video/add', {
              ...this.video,
              engType: this.engType,
            })

        request
          .then(() => {
            this.loading = false
            this.$toast.success(
              this.isEdit
                ? 'Vídeo atualizado com sucesso!'
                : 'Vídeo salvo com sucesso!'
            )
            this.$emit('confirm')
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style scoped></style>
